import { css, Theme } from "@emotion/react"

export const inactiveRowItem = (theme: Theme) => css`
    .MuiTypography-root {
        color: ${theme.palette.Midnight[70]};
    }
`

export const rowItemContent = (theme: Theme) => css`
    display: flex;
    gap: ${theme.spacing(1)};
    align-items: center;
`
